<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_329" data-name="Group 329" transform="translate(-35.342 -280.286)">
    <circle id="Ellipse_17" data-name="Ellipse 17" cx="35.201" cy="35.201" r="35.201" transform="translate(35.342 280.286)" fill="#fff"/>
    <g id="Group_3" data-name="Group 3" transform="translate(-3401.575 -850.394)">
      <rect id="Rectangle_21" data-name="Rectangle 21" width="36" height="6.871" transform="translate(3453.968 1177.742)" fill="#1a1818"/>
      <path id="Path_9" data-name="Path 9" d="M3481.4,1183.016l6.816-12.7-17.18-9.337-11.858,21.849Z" fill="#fff" stroke="#1a1818" stroke-miterlimit="10" stroke-width="3"/>
      <path id="Path_10" data-name="Path 10" d="M3468.142,1169.871l-2.713-8.312-10.768-7.9,1.773-2.42,11.547,8.469,3.012,9.229Z" fill="#fff"/>
      <path id="Path_11" data-name="Path 11" d="M3465.429,1161.558l-3.481-2.553-1.743,1.244a3.145,3.145,0,0,0,.531,5.428l-2.07,1.477a3.146,3.146,0,1,0,3.654,5.123l1.476-1.053,3.955-2.551Z" fill="#1a1818"/>
      <path id="Path_12" data-name="Path 12" d="M3484.983,1152.906s-10.785-7.484-17.467-10.519c-5-2.272-3.581-1.742-3.581-1.742l-8.575,8.551s4.427,3.823,6.29,5.42c.838.718,5.758,4.677,5.758,4.677a1.031,1.031,0,0,1,.371.49c.122.337,3.836,10.623,4.08,11.235a2.406,2.406,0,0,0,1.223,1.153,3,3,0,0,0,4.268-3.507l-2.9-9.987c.118-.246,4.459,8.025,4.459,8.025l4.953-.46,2.61-9.185A4.055,4.055,0,0,0,3484.983,1152.906Z" fill="#1a1818"/>
      <line id="Line_6" data-name="Line 6" x1="4.007" y1="11.535" transform="translate(3475.194 1157.419)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="3"/>
    </g>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'SA_05_02',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/SA_05_02.vue